module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('title-user', [_vm._v("Pedidos")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 min-content"
  }, [
    [(_vm.messageError) ? _c('div', {
      staticClass: "alert alert-warning margin-b10",
      attrs: {
        "role": "alert"
      }
    }, [_vm._v("\n          " + _vm._s(_vm.messageError) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.orders), function(order) {
      return _c('div', {
        key: order.orderId,
        staticClass: "content-box margin-10"
      }, [(_vm.isChangeCard(order)) ? _c('div', {
        staticClass: "request-kind-block"
      }, [_c('a', {
        staticClass: "purple",
        on: {
          "click": function($event) {
            return _vm.showDetail(order)
          }
        }
      }, [_vm._v("\n              " + _vm._s(order.salesOrderId) + "\n            ")]), _vm._v("\n            - TROCA DE CARTÃO\n          ")]) : _c('div', {
        staticClass: "request-kind-block"
      }, [_c('a', {
        staticClass: "purple",
        on: {
          "click": function($event) {
            return _vm.showDetail(order)
          }
        }
      }, [_vm._v("\n              " + _vm._s(order.salesOrderId) + "\n            ")]), _vm._v("\n            - " + _vm._s(order.salesDescription) + "\n          ")]), _vm._v(" "), _c('div', {
        staticClass: "request-status-block"
      }, [_vm._v("\n            " + _vm._s(order.salesOrderStatus.description) + "\n          ")]), _vm._v(" "), _c('div', {
        staticClass: "request-date-block"
      }, [_c('i', {
        staticClass: "icon-clock icon-date"
      }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("date")(order.salesDate)))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("time")(order.salesDate)))])]), _vm._v(" "), _c('div', {
        staticClass: "request-value-block"
      }, [_c('span', {
        class: _vm.getValueClass(order.price)
      }, [_vm._v(_vm._s(_vm._f("cents")(order.price)))])]), _vm._v(" "), _c('div', {
        staticClass: "request-buttons-block"
      }, [(order.salesDescription === 'TRANSFERÊNCIA') ? _c('span', [_c('a', {
        staticClass: "btn btn-print",
        attrs: {
          "data-toggle": "tooltip",
          "title": "Visualizar/Imprimir Comprovante"
        },
        on: {
          "click": function($event) {
            return _vm.showReceipt(order)
          }
        }
      }, [_c('i', {
        staticClass: "icon-printer"
      })])]) : _vm._e(), _vm._v(" "), (order.salesOrderShipment) ? _c('span', [(
        order.salesOrderStatus.salesOrderStatusId == 2 &&
        order.salesOrderShipment.shipmentType == 3
      ) ? _c('span', [_c('a', {
        staticClass: "btn btn-print",
        attrs: {
          "data-toggle": "tooltip",
          "title": "Visualizar/Imprimir Voucher"
        },
        on: {
          "click": function($event) {
            return _vm.exibeVoucher(order)
          }
        }
      }, [_c('i', {
        staticClass: "icon-tag"
      })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (
        order.pixCopiaCola &&
        order.contractPaymentMethod.paymentMethod.paymentShortName ==
        'PX' &&
        order.salesOrderStatus.salesOrderStatusId == 0
      ) ? _c('span', [_c('a', {
        staticClass: "btn btn-icon",
        attrs: {
          "title": "QR Code Pix"
        },
        on: {
          "click": function($event) {
            return _vm.showQRCodePix(order)
          }
        }
      }, [_c('img', {
        staticStyle: {
          "width": "15px",
          "height": "15px"
        },
        attrs: {
          "src": require("../../../assets/img/qrcode-pix.svg")
        }
      })])]) : _vm._e(), _vm._v(" "), (order.bankBillUrl) ? _c('span', [_c('a', {
        staticClass: "btn btn-print",
        attrs: {
          "href": order.bankBillUrl,
          "target": "_blank",
          "data-toggle": "tooltip",
          "title": "Visualizar/Imprimir Boleto"
        }
      }, [_c('i', {
        staticClass: "icon-printer"
      })])]) : _vm._e(), _vm._v(" "), _c('span', [(
        _vm.nfeLinksMap[order.salesOrderId] ||
        _vm.nfeLinksMap[String(order.salesOrderId)]
      ) ? _c('a', {
        staticClass: "btn btn-icon",
        attrs: {
          "data-toggle": "tooltip",
          "title": "Acessar Nota Fiscal",
          "href": _vm.nfeLinksMap[order.salesOrderId] ||
            _vm.nfeLinksMap[String(order.salesOrderId)],
          "target": "_blank"
        }
      }, [_c('img', {
        staticStyle: {
          "width": "18px",
          "height": "18px"
        },
        attrs: {
          "src": require("../../../assets/img/icons/icon-invoice-check.svg"),
          "alt": "Nota Fiscal"
        }
      })]) : _vm._e()]), _vm._v(" "), (!_vm.isChangeCard(order)) ? _c('span', [(_vm.isTransfer(order)) ? _c('a', {
        staticClass: "btn btn-icon",
        attrs: {
          "data-toggle": "tooltip",
          "title": "Detalhes do Pedido"
        },
        on: {
          "click": function($event) {
            return _vm.showReceipt(order)
          }
        }
      }, [_c('i', {
        staticClass: "icon-zoom-in"
      })]) : _c('a', {
        staticClass: "btn btn-icon",
        attrs: {
          "data-toggle": "tooltip",
          "title": "Detalhes do Pedido"
        },
        on: {
          "click": function($event) {
            return _vm.showDetail(order)
          }
        }
      }, [_c('i', {
        staticClass: "icon-zoom-in"
      })])]) : _vm._e()])])
    }), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 text-center"
    }, [_c('pagination', {
      attrs: {
        "model": _vm.page
      },
      on: {
        "page-change": _vm.setCurrentPage
      }
    })], 1)]), _vm._v(" "), (_vm.orders) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12 result-table-count text-center"
    }, [_vm._v("\n            Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a\n            " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + "\n            encontrados.\n          ")])]) : _vm._e()]
  ], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-46ee6ee2!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/request/requests.vue
// module id = 2116
// module chunks = 1